import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class FirEpBumpService {

  constructor(private http: HttpClient) { }

  // 🚀 CRITICAL: Following fir163jsync service pattern exactly
  updateIndicator(
    baseUrl: string,
    saveDtls: any[],
    globalService: any,
    filterParams: any,
    rowData: any,
    logged_in_user: string
  ): Observable<any> {
    
    // 🚀 CRITICAL: URL construction with action codes like AngularJS service
    const url = `${baseUrl}/saveJsonObject?action_code=wa7y6d`;

    // 🚀 CRITICAL: Build AngularJS-compatible payload structure
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    
    // Build jsonSettings exactly like AngularJS service
    const jsonSettings = [{
      'tax_year': filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || new Date().getFullYear(),
      'scenario': filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || 74,
      'jcd_key': filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || 250
    }];
    
    // Build JSON objects exactly like AngularJS service
    const jsonObj = JSON.stringify(saveDtls || []);
    const jsonSettingsStr = JSON.stringify(jsonSettings);
    
    // Extend with jsonObj and jsonSettings
    params = _.extend({ jsonObj: jsonObj }, params);
    params = _.extend({ jsonSettings: jsonSettingsStr }, params);
    
    // 🚀 CRITICAL: Add required configuration parameters with proper fallbacks
    params.tax_year = filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR || new Date().getFullYear();
    params.scenario = filterParams?.scenario || globalService?.scenario || rowData?.SCENARIO || 74;
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || rowData?.JCD_KEY || 250;
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || 'N';
    params.sso_id = logged_in_user || '';
    
    // Set process_name based on component
    params.process_name = "Save/Update First Tier 965 Indicator";

    // 🚀 CRITICAL: Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}